import { Stack, Text } from "@chakra-ui/react";

export default function Terms() {
	return (
		<Stack flex={1} align="center" p={8} borderRadius="4xl">
			<Stack className="center" maxW="2xl">
				<Stack gap={8}>
					<Text fontSize="2xl" fontWeight="bold">
						Terms of Service
					</Text>
					<Text color="fg.muted">
						By downloading, you agree to use the app for personal purposes only, acknowledge that all
						calculations are estimates, understand that in-app purchases are non-refundable and
						subscriptions will renew until cancelled, and accept that the app is provided "as is" without
						warranties.
					</Text>
				</Stack>
			</Stack>
		</Stack>
	);
}
